import React from "react";
import { LibraryCard } from "./LibraryCard";
import { LibraryUIProvider } from "./LibraryUIContext";

export function LibraryPage({ history, match }) {
  const libraryUIEvents = {
    newLibraryButtonClick: () => {
      history.push("/admin/library/new");
    },
    openEditLibraryPage: id => {
      history.push(`/admin/library/${id}/detail`);
    },
    openLibraryFilePage: id => {
      history.push(`/admin/library/file/${id}`);
    }
  };

  return (
    <LibraryUIProvider libraryUIEvents={libraryUIEvents}>
      <LibraryCard history={history} match={match} />
    </LibraryUIProvider>
  );
}
